// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "vendor" + "_" + "973db72caa52900c4b6e" + ".js";
};